// extracted by mini-css-extract-plugin
module.exports = {"root":"Contents_root__39-ki","contents":"Contents_contents__1747a"};